export var PageName;
(function(PageName) {
    PageName["PDP"] = "PDP";
    PageName["BRAND"] = "BRAND";
    PageName["GTM_PDP"] = "GTM_PDP";
    PageName["GTM_BRAND"] = "GTM_BRAND";
    PageName["INVOICE"] = "INVOICE";
    PageName["ORDER"] = "ORDER";
})(PageName || (PageName = {}));
export var TOAST_AUTO_DISMISS_TIME_MS = 2000;
export var VIEW_COUNT_BEFORE_SILENCING_GTM = 5;
